import { Link, useLocation } from 'react-router-dom';
import SiteNav from '@/components/feature/SiteNav';
import Footer from '@/pages/home/components/Footer';

export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <main className="ff-sans min-h-screen bg-white [overflow-x:clip] text-[#111111] flex flex-col">
      <SiteNav />
      <section className="flex-1 flex flex-col items-start justify-center px-4 md:px-10 py-24 md:py-40">
        <p className="text-[11px] md:text-[12px] tracking-wide text-black/40 font-mono break-all">404 — {pathname}</p>
        <h1 className="mt-4 font-normal tracking-[-0.045em] leading-none text-[44px] md:text-[88px]">Nothing grows here.</h1>
        <p className="ff-serif italic text-[16px] md:text-[18px] text-black/60 mt-4">This page doesn&apos;t exist.</p>
        <div className="mt-10 flex flex-wrap gap-6 text-[13px]">
          <Link to="/" className="border-b border-black/30 hover:border-black pb-0.5 whitespace-nowrap cursor-pointer">Back to home</Link>
          <Link to="/shop" className="border-b border-black/30 hover:border-black pb-0.5 whitespace-nowrap cursor-pointer">The Flower Edit →</Link>
        </div>
      </section>
      <Footer />
    </main>
  );
}